import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSiteSettings } from '../context/SiteSettingsContext';

const MaintenancePage = () => {
  const { t } = useTranslation();
  const { storeName } = useSiteSettings();

  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: 'linear-gradient(135deg, #f5f3ff 0%, #ede9fe 50%, #fce7f3 100%)',
      fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
      padding: '2rem',
    }}>
      <div style={{
        textAlign: 'center',
        maxWidth: '520px',
      }}>
        <div style={{ fontSize: '64px', marginBottom: '1rem' }}>🔧</div>
        <h1 style={{
          fontSize: '2rem',
          fontWeight: '700',
          background: 'linear-gradient(135deg, #8B5CF6, #EC4899)',
          WebkitBackgroundClip: 'text',
          WebkitTextFillColor: 'transparent',
          marginBottom: '1rem',
        }}>
          {t('maintenance.title', { storeName })}
        </h1>
        <p style={{
          fontSize: '1.1rem',
          color: '#6b7280',
          lineHeight: '1.7',
        }}>
          {t('maintenance.message')}
        </p>
      </div>
    </div>
  );
};

export default MaintenancePage;
